const project = {
  ui: {
    infopanel: false,
    bottomnav: true,
    inspector: false,
    projecttitle: '',
    headerlogo: 'nikepoc/assets/nike-team-logo.png',
    background: {
      image: './img/Med_vt_rv.png',
      color: '#5F2E2E',
      type: 'babylon'
    }
  },
  scenes: [
    {
      engine: 'babylon',
      scenetitle: '894230 Football Shirt',
      scenefile: 'nikepoc/assets/geometry/894230 football shirt.babylon',
      view: 'start',
      header: 'Nike POC',
      subheader: 'Configurator by Klaas Nienhuis',
      banner: 'nikepoc/assets/894230-orange.png',
      menu: [
        {
          name: 'liquid',
          title: 'Personalize',
          icon: 'mdi-palette',
          options: [
            {material: 'shirt_nike'},
            {liquid: 'shirt_nike'}
          ]
        },
      ],
      player: {template: 'avoidunder', payload: {}},
      background: {template: 'white', payload: {}},
      environment: {template: 'softvignette', payload: {}},
      postprocessing: {template: 'ssao', payload: {}},
      lighting: {template: 'nike', payload: {}},
      annotations: [
      ]
    },
  ]
}

export default project
